module.exports = __webpack_public_path__ + "static/media/3.30d6a988.png";